import { render, staticRenderFns } from "./sectionSubtitle.vue?vue&type=template&id=f1c8817e&scoped=true"
import script from "./sectionSubtitle.vue?vue&type=script&lang=js"
export * from "./sectionSubtitle.vue?vue&type=script&lang=js"
import style0 from "./sectionSubtitle.vue?vue&type=style&index=0&id=f1c8817e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c8817e",
  null
  
)

export default component.exports